// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter---IK7w5"};